import { render, staticRenderFns } from "./PlanetColorPicker.vue?vue&type=template&id=388b990a&scoped=true"
import script from "./PlanetColorPicker.vue?vue&type=script&lang=js"
export * from "./PlanetColorPicker.vue?vue&type=script&lang=js"
import style0 from "./PlanetColorPicker.vue?vue&type=style&index=0&id=388b990a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388b990a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388b990a')) {
      api.createRecord('388b990a', component.options)
    } else {
      api.reload('388b990a', component.options)
    }
    module.hot.accept("./PlanetColorPicker.vue?vue&type=template&id=388b990a&scoped=true", function () {
      api.rerender('388b990a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/PlanetColorPicker.vue"
export default component.exports